/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { CreateProfessionDTO } from "../models";
import { Number12 } from "../models";
import { RemoveProfessionDTO } from "../models";
import { UpdateProfessionDTO } from "../models";
/**
 * ProfessionApi - axios parameter creator
 * @export
 */
export const ProfessionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {CreateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    professionControllerCreateProfession: async (
      body: CreateProfessionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling professionControllerCreateProfession."
        );
      }
      const localVarPath = `/v1/cms/api/profession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {Number12} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    professionControllerGetProfession: async (
      pageNumber: number,
      pageIndex: number,
      name?: string,
      status?: Number12,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling professionControllerGetProfession."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling professionControllerGetProfession."
        );
      }
      const localVarPath = `/v1/cms/api/profession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RemoveProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    professionControllerRemoveProfession: async (
      body: RemoveProfessionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling professionControllerRemoveProfession."
        );
      }
      const localVarPath = `/v1/cms/api/profession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    professionControllerUpdateProfession: async (
      body: UpdateProfessionDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          "body",
          "Required parameter body was null or undefined when calling professionControllerUpdateProfession."
        );
      }
      const localVarPath = `/v1/cms/api/profession`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || "";

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProfessionApi - functional programming interface
 * @export
 */
export const ProfessionApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerCreateProfession(
      body: CreateProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ProfessionApiAxiosParamCreator(
        configuration
      ).professionControllerCreateProfession(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {Number12} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerGetProfession(
      pageNumber: number,
      pageIndex: number,
      name?: string,
      status?: Number12,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ProfessionApiAxiosParamCreator(
        configuration
      ).professionControllerGetProfession(
        pageNumber,
        pageIndex,
        name,
        status,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {RemoveProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerRemoveProfession(
      body: RemoveProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ProfessionApiAxiosParamCreator(
        configuration
      ).professionControllerRemoveProfession(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {UpdateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerUpdateProfession(
      body: UpdateProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ProfessionApiAxiosParamCreator(
        configuration
      ).professionControllerUpdateProfession(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ProfessionApi - factory interface
 * @export
 */
export const ProfessionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {CreateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerCreateProfession(
      body: CreateProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ProfessionApiFp(configuration)
        .professionControllerCreateProfession(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [name]
     * @param {Number12} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerGetProfession(
      pageNumber: number,
      pageIndex: number,
      name?: string,
      status?: Number12,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ProfessionApiFp(configuration)
        .professionControllerGetProfession(
          pageNumber,
          pageIndex,
          name,
          status,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RemoveProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerRemoveProfession(
      body: RemoveProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ProfessionApiFp(configuration)
        .professionControllerRemoveProfession(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateProfessionDTO} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async professionControllerUpdateProfession(
      body: UpdateProfessionDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ProfessionApiFp(configuration)
        .professionControllerUpdateProfession(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProfessionApi - object-oriented interface
 * @export
 * @class ProfessionApi
 * @extends {BaseAPI}
 */
export class ProfessionApi extends BaseAPI {
  /**
   *
   * @param {CreateProfessionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfessionApi
   */
  public async professionControllerCreateProfession(
    body: CreateProfessionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ProfessionApiFp(this.configuration)
      .professionControllerCreateProfession(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [name]
   * @param {Number12} [status]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfessionApi
   */
  public async professionControllerGetProfession(
    pageNumber: number,
    pageIndex: number,
    name?: string,
    status?: Number12,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ProfessionApiFp(this.configuration)
      .professionControllerGetProfession(
        pageNumber,
        pageIndex,
        name,
        status,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {RemoveProfessionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfessionApi
   */
  public async professionControllerRemoveProfession(
    body: RemoveProfessionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ProfessionApiFp(this.configuration)
      .professionControllerRemoveProfession(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {UpdateProfessionDTO} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfessionApi
   */
  public async professionControllerUpdateProfession(
    body: UpdateProfessionDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ProfessionApiFp(this.configuration)
      .professionControllerUpdateProfession(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
